import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between rounded-xs text-center overflow-hidden" }

import {
  MedicationOrderBoxStatus,
  MedicationOrderStatus,
} from "@/interfaces/enum/medicationOrderStatus";
import { StorageLocation } from "@/interfaces/enum/StorageLocation";
import { Message } from "@/interfaces/message";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeTag',
  props: {
    boxes: {},
    property: {},
    value: {},
    type: {},
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

function historyObject(): { color: string; value: string } {
  let value = " – ";
  if (props.property == "box") {
    let box = props.boxes.find((box) => box.id == props.value);
    if (box === undefined) return { color: "white", value: value };
    return {
      color: "white",
      value: box.medication_box?.name ?? "unbenannte Kiste",
    };
  }
  if (props.property == "status") {
    let states = MedicationOrderStatus;
    if (props.type == "box") {
      states = MedicationOrderBoxStatus;
    }
    let status = states.find((state) => state.id == props.value);
    return {
      color: colorOfProgress(status?.progress),
      value: status?.name ?? value,
    };
  }
  if (props.property == "storage_location") {
    let storageLocations = StorageLocation;
    let storageLocation = storageLocations.find(
      (location) => location.id == props.value
    );
    return {
      color: "white",
      value: storageLocation?.name ?? value,
    };
  }
  if (props.property == "patient_id") {
    const patient = useManagedPatientsStore().patientsMap?.get(props.value);
    if (patient) {
      value = `${patient.currentProfile?.firstName} ${patient.currentProfile?.lastName}`;
    }
    if (props.value == 0) {
      value = "Verbrauchsmaterial";
    }
    return { color: "white", value: value };
  }
  return { color: "white", value: props.value ?? value };
}

function colorOfProgress(progress?: number): string {
  switch (progress) {
    case 0:
      return "gray";
    case 1:
      return "blue";
    case 2:
      return "orange";
    case 3:
      return "green";
    case 4:
      return "red";
    case 5:
      return "yellow";
  }
  return "white";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-xs grid place-content-center w-full px-xs", {
        [`bg-gray-600`]: historyObject().color == 'gray',
        [`bg-red`]: historyObject().color == 'red',
        [`bg-blue-3`]: historyObject().color == 'blue',
        [`bg-orange`]: historyObject().color == 'orange',
        [`bg-green`]: historyObject().color == 'green',
        [`bg-yellow-300`]: historyObject().color == 'yellow',
        'w-auto': _ctx.small,
        'rounded-xs': _ctx.small,
      }])
    }, _toDisplayString(historyObject().value), 3)
  ]))
}
}

})